module.exports = __webpack_public_path__ + "static/img/10.c6a2dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ajbz/10.png
// module id = w7Rj
// module chunks = 0